module.exports = __webpack_public_path__ + "img/icon_pdf.814e783d.png";